
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta } from "/app/pages/index.vue?macro=true";
import { default as resultsch22nVLPxjv9XDGw_BoM18_45PJbJrddbkh5RylYGIp0cMeta } from "/app/pages/receipts/results.vue?macro=true";
export default [
  {
    name: "index___de",
    path: "/",
    meta: {"middleware":["client-data"]},
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___en",
    path: "/en",
    meta: {"middleware":["client-data"]},
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___fr",
    path: "/fr",
    meta: {"middleware":["client-data"]},
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___nl",
    path: "/nl",
    meta: {"middleware":["client-data"]},
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___da",
    path: "/da",
    meta: {"middleware":["client-data"]},
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___hu",
    path: "/hu",
    meta: {"middleware":["client-data"]},
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___it",
    path: "/it",
    meta: {"middleware":["client-data"]},
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___es",
    path: "/es",
    meta: {"middleware":["client-data"]},
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "receipts-results___de",
    path: "/receipts/results",
    meta: resultsch22nVLPxjv9XDGw_BoM18_45PJbJrddbkh5RylYGIp0cMeta || {},
    component: () => import("/app/pages/receipts/results.vue")
  },
  {
    name: "receipts-results___en",
    path: "/en/receipts/results",
    meta: resultsch22nVLPxjv9XDGw_BoM18_45PJbJrddbkh5RylYGIp0cMeta || {},
    component: () => import("/app/pages/receipts/results.vue")
  },
  {
    name: "receipts-results___fr",
    path: "/fr/receipts/results",
    meta: resultsch22nVLPxjv9XDGw_BoM18_45PJbJrddbkh5RylYGIp0cMeta || {},
    component: () => import("/app/pages/receipts/results.vue")
  },
  {
    name: "receipts-results___nl",
    path: "/nl/receipts/results",
    meta: resultsch22nVLPxjv9XDGw_BoM18_45PJbJrddbkh5RylYGIp0cMeta || {},
    component: () => import("/app/pages/receipts/results.vue")
  },
  {
    name: "receipts-results___da",
    path: "/da/receipts/results",
    meta: resultsch22nVLPxjv9XDGw_BoM18_45PJbJrddbkh5RylYGIp0cMeta || {},
    component: () => import("/app/pages/receipts/results.vue")
  },
  {
    name: "receipts-results___hu",
    path: "/hu/receipts/results",
    meta: resultsch22nVLPxjv9XDGw_BoM18_45PJbJrddbkh5RylYGIp0cMeta || {},
    component: () => import("/app/pages/receipts/results.vue")
  },
  {
    name: "receipts-results___it",
    path: "/it/receipts/results",
    meta: resultsch22nVLPxjv9XDGw_BoM18_45PJbJrddbkh5RylYGIp0cMeta || {},
    component: () => import("/app/pages/receipts/results.vue")
  },
  {
    name: "receipts-results___es",
    path: "/es/receipts/results",
    meta: resultsch22nVLPxjv9XDGw_BoM18_45PJbJrddbkh5RylYGIp0cMeta || {},
    component: () => import("/app/pages/receipts/results.vue")
  }
]